import { hasSubscription } from './permission'

export const policyHelper = {
  hasSubscription,
}
